export const ROLE_LABELS = {
  admin: "Admin",
  user: "User",
};
